import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { appsAPI } from '../../services/api'
import { formatEuro, toNumber } from '../../utils/format'
import AppIcon from '../../components/public/AppIcon'

import { logger } from '@/utils/logger';
export default function Apps() {
  const [apps, setApps] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    loadApps()
  }, [])

  const loadApps = async () => {
    try {
      const response = await appsAPI.getAll()
      setApps(response.data)
    } catch (error) {
      logger.error('Error loading apps:', error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="wc-container" style={{ padding: '72px 32px' }}>
      <p className="wc-kicker">Apps</p>
      <h1 style={{ maxWidth: 620, marginBottom: 12 }}>Unsere Apps</h1>
      <p className="wc-muted" style={{ maxWidth: 560, marginBottom: 48, fontSize: 17 }}>
        Entdecken Sie unsere professionellen Werkstatt-Lösungen — jede App
        einzeln buchbar, alle über ein Kundenportal verwaltet.
      </p>

      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '48px 0' }}>
          <span className="wc-spinner" role="status" aria-label="Lade Apps" />
        </div>
      ) : apps.length === 0 ? (
        <div className="wc-card wc-elev-sm" style={{ padding: 32, alignItems: 'center' }}>
          <p className="wc-muted" style={{ margin: 0 }}>
            Derzeit sind keine Apps verfügbar.
          </p>
        </div>
      ) : (
        <div className="wc-grid-3" style={{ gap: 20 }}>
          {apps.map(app => (
            <div key={app.id} className="wc-card wc-elev-sm wc-card-hover">
              {app.image_url && (
                <img
                  src={app.image_url}
                  alt=""
                  loading="lazy"
                  style={{
                    width: '100%',
                    height: 168,
                    objectFit: 'cover',
                    borderRadius: 'var(--wc-radius-md)',
                  }}
                />
              )}

              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: 12,
                  marginTop: 4,
                }}
              >
                {!app.image_url ? <AppIcon app={app} /> : <span />}
                {app.is_featured && <span className="wc-tag wc-tag-accent">Beliebt</span>}
              </div>

              <h2 className="wc-card-title" style={{ fontSize: 20, marginBottom: 0 }}>
                {app.name}
              </h2>
              <p className="wc-card-body">{app.short_description}</p>

              {toNumber(app.price_monthly) > 0 && (
                <div style={{ marginTop: 4 }}>
                  <p style={{ margin: 0, fontSize: 20, color: 'var(--wc-accent)' }}>
                    ab {formatEuro(app.price_monthly)}
                    <span className="wc-muted" style={{ fontSize: 13 }}> / Monat</span>
                  </p>
                  {toNumber(app.price_yearly) > 0 && (
                    <p className="wc-muted" style={{ margin: 0, fontSize: 13 }}>
                      oder ab {formatEuro(app.price_yearly)} / Jahr
                    </p>
                  )}
                </div>
              )}

              <div style={{ display: 'flex', gap: 8, marginTop: 8, flexWrap: 'wrap' }}>
                <Link to={`/apps/${app.slug}`} className="wc-btn wc-btn-primary">
                  Details
                </Link>
                {app.demo_url && (
                  <a
                    href={app.demo_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="wc-btn wc-btn-secondary"
                  >
                    Demo
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
